import { observable, action } from 'mobx';
import gql from 'graphql-tag';

const ReadCouncilsQuery = gql`
    query ReadCouncilsQuery {
        readCouncils {
            ID
            Title
            Region
            Council
            Zone
            ConsentZone
            AssumedExternalTemperature
            Error
        }
    }
`,

    HomeDetailsMutation = gql`
    mutation HomeDetailsMutation($URLID: String!, $HomeDetails: String!) {
        toolSubmissionMutation(URLID: $URLID, HomeDetails: $HomeDetails) {
            URLID
            Era
            Zone
            IsApartment
            ConsentZone
            ConsentZoneCompliant
            FranklinCouncil
            Retrofitted2009
            Standards2009Compliant
            RValueEra
            ResultCalculator
            AssumedExternalTemperature
            HomeDetails
            Error
        }
    }
`;
export class HomeDetailsStore {
    appStore;

    @observable goNext = false;

    @observable loading = false;

    @observable isReadOnly = false;

    @action reset() {
        this.goNext = false;
        this.loading = false;
        this.isReadOnly = false;
    }

    constructor(opts) {
        this.appStore = opts.appStore;
    }

    @action setIsReadOnly(value) {
        this.isReadOnly = value;
    }

    async initializeCouncils() {
        if (this.appStore.councils.length > 0) {
            // we've already retrieved councils, and they are unlikely to change
            return;
        }
        const result = await this.appStore.apolloClient
            .query({
                query: ReadCouncilsQuery,
                fetchPolicy: 'network-only'
            })
            .catch(e => {
                this.loading = false;
                return false;
            });

        if (
            result &&
            result.data.readCouncils &&
            result.data.readCouncils.length > 0
        ) {
            this.loading = false;
            this.appStore.setCouncils(result.data.readCouncils.slice());
        }
    }

    getMutation(values) {
        return {
            mutation: HomeDetailsMutation,
            variables: {
                URLID: this.appStore.submissionID.toString(),
                HomeDetails: JSON.stringify(values.homedetails)
            },
            fetchPolicy: 'no-cache',
            context: {
                headers: {
                    'X-CSRF-TOKEN': this.appStore.sectoken
                }
            }
        };
    }

    async save(values, form, goNext) {
        this.loading = true;
        this.appStore.updateUserData(values.homedetails, 'homedetails', false);
        this.appStore.save(this.getMutation(values), this, form, goNext);
    }
}
